// @flow
import React, {useEffect, useMemo, useState} from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import {makeStyles} from '@material-ui/core/styles';
import {colors} from '../../../assets/styles/colors';
import {InfoOutlined, PlayCircleFilledTwoTone, Share} from '@material-ui/icons';
import {
  Hidden,
  Grid,
  Divider,
  ClickAwayListener,
  Tooltip,
  useMediaQuery,
} from '@material-ui/core';
import OrderCard from './OrderCard';
import LocalMallOutlinedIcon from '@material-ui/icons/LocalMallOutlined';
import DashboardOutlinedIcon from '@material-ui/icons/DashboardOutlined';
import {usePage} from '../../page/utils';
import {Link, useHistory} from 'react-router-dom';
import purpleEllipsesPageViewsBackground from '../../../assets/img/dashboard/purpleEllipsesPageViewsBackground.svg';
import whiteGlobe from '../../../assets/img/dashboard/whiteGlobe.svg';
// import idea from '../../../assets/img/idea.svg';
import referralImg from '../../../assets/img/referralImg.svg';

// import herramientasDigitales from '../../../assets/img/herramientasDigitales.svg';
// import telegramLogo from '../../../assets/img/telegramLogo.svg';
// import inviteFriends from '../../../assets/img/invite-referral.png';
// import demoDay from '../../../assets/img/demoDay.png';

import {LEGACY_TIERS, NON_PAID_TIERS, ORDER_STATES} from '../../../entities';
import type {
  User,
  Currency,
  Store,
  ResellerInformation,
  Subscription,
  SubscriptionSetting,
} from '../../../entities';
import type {
  OrderData,
  ProductCategoryData,
  ProductData,
  SalesData,
  DashboardAction,
} from '../duck';
import AlertDueDateTier from '../../tiers/components/AlertDueDateTier/AlertDueDateTier';
import dayjs from 'dayjs';
import CustomButton from '../../../elements/CustomButton/CustomButton';
import {
  PieChart,
  Pie,
  Cell,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Bar,
  Tooltip as RechartsTooltip,
  ResponsiveContainer,
} from 'recharts';

import {commaFormat} from '../../../utils/number';
import {getImageUrl} from '../../../utils/image_provider';
import {abvMonthStrings} from '../../../utils/date';
import TelegramModal from '../../home/components/Modals/TelegramModal';
import EventsSection from '../../home/components/EventsSection';
import ReferralModal from '../../home/components/Modals/ReferralModal';
// import WelcomeModal from './modals/WelcomeModal';
import OtherConfigurations from './OtherConfigurations';
import {getCustomDomain, useIsFeatureInTier} from '../../../utils/component';
import FreeTrialBanner from '../../../elements/FreeTrialBanner/FreeTrialBanner';
import ConsultancyPageAlert from '../../../elements/ConsultancyPageAlert';
import {TIENDADA_LINKS} from '../../../constants';

type Props = {|
  user?: User,
  store?: Store,
  productsCount?: number,
  fetchDataAnalytics?: ({dateIni: string, dateEnd: string}) => void,
  orderData?: OrderData,
  productCategoryData?: ProductCategoryData,
  productData?: ProductData,
  salesData?: SalesData,
  isFetchingData?: boolean,
  error?: string,
  currency?: Currency,
  dateIni?: Date,
  errorAnalyticsFetched?: string,
  fetchDataAnalytics: () => void,
  pageViews?: number,
  fetchSummaryProductsCount: () => void,
  fetchPageViews: () => void,
  fetchSummaryProducts: (payload: DashboardAction) => void,
  fetchSummaryOrders: (payload: DashboardAction) => void,
  fetchSummaryProductCategories: () => void,
  fetchSummarySales: () => void,
  resellerInformation: ResellerInformation,
  isFetchingResellerInformation: boolean,
  points?: number,
  subscription?: Subscription,
  dueInformation?: Subscription,
  subscriptionSetting?: SubscriptionSetting,
|};

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: 1500,
    // display: 'flex',
    // flexDirection: 'column',
    background: '#f8f9fb',
    paddingBottom: 96,
  },
  greeting: {
    fontSize: '1.5rem',
    margin: theme.spacing(2, 4, 0, 4),
  },
  bold: {
    fontWeight: 600,
  },
  welcome: {
    margin: theme.spacing(1, 4, 0, 4),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  tutorialsButton: {
    marginLeft: theme.spacing(2),
    backgroundColor: 'white',
    color: colors.purple3,
    padding: '4px 13px',
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    [theme.breakpoints.down('xs')]: {
      backgroundColor: 'unset',
      color: colors.purple3,
      padding: 0,
      boxShadow: 'unset',
    },
  },
  pageViewCountBanner: {
    margin: theme.spacing(2, 4, 0, 4),
    // width: '100%',
    height: 72,
    borderRadius: '16px',
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    padding: theme.spacing(2, 3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    overflow: 'visible',
    color: 'white',
    background: colors.purple3,
    backgroundImage: `url(${purpleEllipsesPageViewsBackground})`,
    backgroundSize: '100% 100%',
  },
  pageViewsText: {
    fontWeight: 500,
    [theme.breakpoints.only('xs')]: {
      marginTop: '8px',
    },
  },
  pageViews: {
    fontWeight: 600,
    fontSize: '2rem',
    whiteSpace: 'nowrap',
  },
  divider: {
    background: colors.grey300,
  },
  pageViewsBannerDomain: {
    marginLeft: theme.spacing(2),
    fontWeight: 500,
    fontSize: '1.125rem',
  },
  pageViewsBannerShareStoreButton: {
    color: 'white',
    fontSize: '0.875rem',
    '& .MuiButton-label': {
      flexDirection: 'row',
    },
    [theme.breakpoints.only('xs')]: {
      marginTop: '-8px',
    },
  },
  actionButtonInfoIcon: {
    color: 'white',
    marginLeft: 'auto',
  },
  infoTooltip: {
    color: colors.purple3,
    backgroundColor: colors.lightPurple,
    borderRadius: '8px',
    textAlign: 'left',
    maxWidth: 320,
  },
  gridContainer: {
    margin: theme.spacing(3, 4, 0, 4),
    // [theme.breakpoints.only('sm')]: {
    //   padding: theme.spacing(2, 3, 0, 4),
    // },
    // [theme.breakpoints.down('xs')]: {
    //   padding: theme.spacing(2, 1, 0, 2),
    // },
  },
  leftContent: {
    flex: '1 1 30%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    borderRadius: '16px',
    boxShadow:
      '0px 0px 1px rgba(181, 181, 181, 0.2), 0px 2px 8px rgba(209, 209, 209, 0.16)',
    padding: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(3, 2, 2, 2),
    },
    background: 'white',
  },
  rightContent: {
    flex: '1 1 70%',
    width: '100%',
    [theme.breakpoints.up('lg')]: {
      marginLeft: theme.spacing(4),
    },
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(4),
    },
    [theme.breakpoints.down('xs')]: {
      marginTop: theme.spacing(2),
    },
    borderRadius: '12px',
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    background: colors.purple3,
  },
  navBackground: {
    [theme.breakpoints.down('sm')]: {
      background: 'white !important',
    },
  },
  title: {
    fontSize: '24px',
    fontWeight: 600,
    color: 'black',
  },
  logo: {
    height: 48,
    width: 'auto',
  },
  dashboardItem: {
    position: 'relative',
    overflow: 'hidden',
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
    padding: '15px',
    borderRadius: '12px',
    boxShadow:
      '0px 0px 1px rgba(181, 181, 181, 0.2), 0px 2px 8px rgba(209, 209, 209, 0.16)',
  },
  dashboardHeader: {
    display: 'flex',
    alignItems: 'center',
    '& img': {
      marginRight: '0.5rem',
    },
  },
  dashboardItemClickable: {
    '&:hover': {
      cursor: 'pointer',
      filter: 'brightness(0.95)',
    },
  },
  dashboardItemTitle: {
    fontWeight: 600,
  },
  emptyChartBackdrop: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: '#ffffff10',
    backdropFilter: 'blur(2px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  emptyChartAlert: {
    background: colors.grey200,
    borderRadius: '24px',
    width: 260,
    padding: theme.spacing(3),
    textAlign: 'center',
    fontSize: '0.875rem',
    fontWeight: 500,
  },
  wraperIcon: {
    backgroundColor: '#F5F0FF',
    borderRadius: '50%',
    padding: theme.spacing(1),
    width: '40px',
    height: '40px',
  },
  icon: {
    color: colors.purple3,
  },
  cardContent: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  amountCard: {
    fontSize: '22px',
    fontWeight: 600,
    color: colors.grey900,
    textAlign: 'left',
  },
  titleText: {
    fontSize: '14px',
    fontWeight: 500,
    color: colors.grey900,
    textAlign: 'left',
  },
  col: {
    display: 'flex',
    flexDirection: 'column',
  },
  firstSection: {
    height: '100%',
  },
  chartDescription: {
    marginTop: 4,
    fontSize: '0.875rem',
    color: colors.grey600,
  },
  pieChartContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    margin: '0px 0 0px -16px',
  },
  pieChartLegends: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  pieChartLabel: {
    fontWeight: 500,
  },
  product: {
    display: 'flex',
    alignItems: 'center',
    margin: '16px 8px 0 8px',
  },
  productNumber: {
    color: colors.grey600,
    width: 24,
    minWidth: 24,
  },
  productImage: {
    height: 44,
    width: 44,
    objectFit: 'cover',
    borderRadius: '12px',
    marginRight: theme.spacing(2),
  },
  productName: {
    color: colors.grey800,
    fontSize: '0.875rem',
    display: '-webkit-box',
    lineClamp: 2,
    overflow: 'hidden',
    '-webkit-box-orient': 'vertical',
    marginRight: theme.spacing(2),
  },
  productSalesCount: {
    marginLeft: 'auto',
    textAlign: 'center',
    fontSize: '0.75rem',
    '& b': {
      fontSize: '0.875rem',
    },
  },
  actionButton: {
    width: '100%',
    height: '100%',
    backgroundColor: 'white',
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    borderRadius: '12px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    '& .MuiButton-label': {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      // justifyContent: 'space-between',
    },
    padding: theme.spacing(2, 4),
  },
  actionButtonLabel: {
    margin: theme.spacing(2),
    whiteSpace: 'pre-line',
    textAlign: 'center',
    fontWeight: 600,
    fontSize: '1rem',
  },
  actionButtonImage: {
    margin: theme.spacing(0, 2),
  },
  thirdActionButton: {
    [theme.breakpoints.only('xs')]: {
      '& .MuiButton-label': {
        flexDirection: 'row',
      },
    },
  },
  extraButton: {
    backgroundColor: '#6926F1',
    borderRadius: theme.spacing(3),
    padding: theme.spacing(3),
    justifyContent: 'space-evenly',
    [theme.breakpoints.down('xs')]: {
      flexWrap: 'wrap',
      padding: theme.spacing(2),
      justifyContent: 'space-evenly',
    },
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    // alignItems: 'center',
  },
  extraButtonText: {
    textAlign: 'center',
    color: 'white',
    fontWeight: 600,
    marginBottom: 'auto',
    [theme.breakpoints.down('xs')]: {
      marginBottom: 'unset',
    },
  },
  extraButtonButton: {
    marginTop: theme.spacing(2),
    // padding: '6px 24px',
    color: 'white',
    border: '1px solid white',
  },
  availableSoon: {
    color: colors.grey800,
    fontSize: '0.75rem',
    position: 'absolute',
    top: 12,
    left: 12,
    width: 65,
    whiteSpace: 'break-spaces',
    lineHeight: '0.875rem',
    textAlign: 'left',
    [theme.breakpoints.only('xs')]: {
      marginTop: theme.spacing(1),
      position: 'unset',
      width: 'unset',
      textAlign: 'unset',
    },
  },
  demoDayActionButton: {
    width: '100%',
    height: '100%',
    backgroundColor: colors.lightPurple,
    color: colors.purple3,
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    borderRadius: '12px',
    '& .MuiButton-label': {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      // justifyContent: 'space-between',
    },
    padding: theme.spacing(1, 2),
  },
  demoDayActionButtonImage: {
    height: 60,
  },
  demoDayActionButtonLabel: {
    fontSize: '1.5rem',
    fontWeight: 600,
    whiteSpace: 'normal',
    lineHeight: '1.5rem',
  },
  demoDayActionButtonSubLabel: {
    textAlign: 'center',
    marginTop: 8,
    fontSize: '0.875rem',
    fontWeight: 600,
  },
  containerEarnedPoints: {
    height: '100%',
    backgroundColor: '#F5F0FF',
    borderRadius: '8px',
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  wrapperImgReferred: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  inviteFriend: {
    // width: '6rem',
    width: '100px',
    margin: '0 auto',
  },
  earnedText: {
    color: '#5E1FDB',
    fontSize: '14px',
    fontWeight: 500,
    [theme.breakpoints.up('md')]: {
      fontSize: '16px',
    },
  },
  smallEarnedText: {
    color: '#5E1FDB',
    fontSize: '12px',
    fontWeight: 500,
  },
  earnedPoints: {
    color: '#5E1FDB',
    fontSize: '24px',
    fontWeight: 600,
  },
  btnKnowReferral: {
    marginTop: '1rem',
    fontWeight: 600,
    backgroundColor: '#FFDF65',
    borderRadius: '32px',
    color: '#500BDB',
    padding: theme.spacing(1, 2),
    '&:hover': {
      backgroundColor: '#FBBF34!important',
    },
  },
  containerShowPoints: {
    width: '100%',
    background: '#F5F0FF',
    borderRadius: '8px',
    padding: theme.spacing(1),
  },
  showPoints: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  learnPro: {
    width: '100%',
    margin: theme.spacing(4),
    display: 'flex',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  textPro: {
    textAlign: 'center',
    color: '#7B39FF',
    fontSize: '18px',
    fontWeight: 600,
    '& span': {
      backgroundColor: '#7B39FF',
      color: '#FFFFFF',
      padding: '0 5px',
    },
  },
  seeDetails: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(1, 4),
    border: '1px solid #7B39FF',
    fontSize: '14px',
    color: '#7B39FF',
  },
  referralBtn: {
    padding: '0',
    display: 'inline',
  },
}));

export default usePage<Props>(Dashboard, 'Dashboard');

const pieChartColors = ['#7B39FF', '#3DD598', '#FFC442', '#FE974A', '#158CFD'];

const RADIAN = Math.PI / 180;
const renderCustomizedPieLabel = props => {
  const {cx, cy, midAngle, innerRadius, outerRadius, percent} = props;
  const radius = innerRadius + (outerRadius - innerRadius) * 1.25;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="black"
      fontWeight={500}
      textAnchor={x > cx ? 'start' : 'end'}
      dominantBaseline="central"
    >
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

const CustomBarchartTooltip = ({
  active,
  payload,
  label,
  currency,
}: {
  active?: any,
  payload?: any,
  label?: string,
  currency?: any,
}) => {
  if (active && payload && payload.length && currency) {
    return (
      <div
        style={{
          background: '#500BDB',
          color: 'white',
          borderRadius: '8px',
          padding: '2px 8px',
        }}
      >
        <p style={{fontSize: '0.875rem', fontWeight: 500}}>
          {commaFormat(payload[0].value, currency.symbol)}
        </p>
      </div>
    );
  }

  return null;
};

function Dashboard(props: Props) {
  const {
    user,
    store,
    isFetchingData,
    productCategoryData,
    productData,
    orderData,
    currency,
    productsCount,
    pageViews,
    fetchPageViews,
    fetchSummaryProductsCount,
    fetchSummaryProducts,
    fetchSummaryOrders,
    fetchSummaryProductCategories,
    fetchSummarySales,
    salesData,
    points,
  } = props;
  const classes = useStyles();
  const history = useHistory();

  const hasCollaboratorDashboardFeature = useIsFeatureInTier(
    'DASHBOARD_COLLABORATOR'
  );
  const hasFullDashboardFeature =
    !!user &&
    (user.type === 'collaborator-user'
      ? hasCollaboratorDashboardFeature
      : true);

  useEffect(() => {
    if (user) {
      const date = new Date();
      const offset = date.getTimezoneOffset();
      let year = date.getUTCFullYear();
      // year = month === 12 ? year - 1 : year;
      // const month = date.getMonth() % 12;
      const month = date.getUTCMonth();
      const startDateISOString = new Date(
        Date.UTC(year, month, 1, 0, offset)
      ).toISOString();
      // const endDateISOString = new Date(
      //   Date.UTC(year, month + 1, 1, 0, offset)
      // ).toISOString();

      // fetchDataAnalytics();
      fetchPageViews();
      fetchSummaryProducts({productsRequest: {size: '10', page: '0'}});
      fetchSummaryOrders({
        dateRange: {
          // end_date: endDateISOString,
          start_date: startDateISOString,
        },
      });
      fetchSummaryProductCategories();
      fetchSummarySales();
      fetchSummaryProductsCount();
    }
  }, [
    fetchPageViews,
    fetchSummaryOrders,
    fetchSummaryProductCategories,
    fetchSummaryProducts,
    fetchSummaryProductsCount,
    fetchSummarySales,
    user,
  ]);

  const [linkCopied, setLinkCopied] = useState(false);

  const PageViewsShareStoreButton = () => (
    <ClickAwayListener onClickAway={() => setLinkCopied(false)}>
      <Tooltip
        placement="top"
        arrow
        PopperProps={{
          disablePortal: true,
        }}
        onClose={() => setLinkCopied(false)}
        open={linkCopied}
        disableHoverListener
        disableTouchListener
        leaveDelay={300}
        title="¡Link copiado!"
      >
        <div>
          <CustomButton
            className={classes.pageViewsBannerShareStoreButton}
            startIcon={<Share />}
            onClick={() => {
              !!store &&
                navigator &&
                navigator.clipboard &&
                navigator.clipboard
                  .writeText(`https://${getCustomDomain(store)}`)
                  .then(() => setLinkCopied(true))
                  .catch(e => console.error(e));
            }}
          >
            Compartir Tienda
          </CustomButton>
        </div>
      </Tooltip>
    </ClickAwayListener>
  );

  const haveReferreds = useMemo(() => points && points > 0, [points]);

  const mobile = useMediaQuery('(max-width:600px)');

  const [emptySalesData, setEmptySalesData] = useState(false);
  const processedSalesData = useMemo(() => {
    if (salesData) {
      const data = [];
      const currentMonth = dayjs().month();
      // const salesDataToProcess = mobile ? salesData.slice(-6) : salesData;
      let allZero = true;
      abvMonthStrings.forEach((m, i) => {
        if (!mobile || i > 5) {
          if (salesData[i] && parseFloat(salesData[i].amount) > 0)
            allZero = false;
          data.push({
            month: abvMonthStrings[(i + 1 + currentMonth) % 12],
            amount: salesData[i] ? parseFloat(salesData[i].amount) : 0,
          });
        }
      });
      if (allZero) {
        setEmptySalesData(true);
      } else setEmptySalesData(false);
      return data;
    }
  }, [mobile, salesData]);

  const [showMoreProds, setShowMoreProds] = useState(false);

  const salesPerCategory = useMemo(() => {
    if (productCategoryData && productCategoryData.salesPerCategory) {
      return productCategoryData.salesPerCategory.map(s => {
        return {
          name: s.name,
          amount: parseFloat(s.amount),
        };
      });
    }
  }, [productCategoryData]);
  const salesGroupCategories = useMemo(() => {
    if (salesPerCategory) {
      if (salesPerCategory.length > 5) {
        let amount = 0;
        salesPerCategory
          .slice(4, -1)
          .forEach(i => (amount = amount + i.amount));

        return [
          ...salesPerCategory.slice(0, 4),
          {
            name: 'Otros',
            amount,
          },
        ];
      } else return salesPerCategory;
    }
  }, [salesPerCategory]);

  const pieChart = salesGroupCategories && (
    <div className={classes.pieChartContainer}>
      <PieChart width={240} height={190} margin={{top: 16, bottom: 16}}>
        <Pie
          data={
            salesGroupCategories && salesGroupCategories.length
              ? salesGroupCategories
              : [{name: 'Categoría', amount: 1}]
          }
          dataKey="amount"
          nameKey="name"
          cx="50%"
          cy="50%"
          innerRadius={55}
          outerRadius={75}
          fill="#82ca9d"
          label={renderCustomizedPieLabel}
          labelLine={false}
          animationBegin={0}
          animationDuration={1000}
          isAnimationActive={false}
        >
          {(salesGroupCategories && salesGroupCategories.length
            ? salesGroupCategories
            : [{name: 'Categoría', amount: 1}]
          ).map((entry, i) => (
            <Cell
              key={`cell-${i}`}
              fill={pieChartColors[i % pieChartColors.length]}
            />
          ))}
        </Pie>
        <RechartsTooltip
          contentStyle={{
            background: '#9595AB',
            border: 'none',
            padding: '0 8px',
            borderRadius: '8px',
          }}
          itemStyle={{
            fontSize: 12,
            color: 'white',
            fontWeight: 500,
          }}
        />
      </PieChart>
      <div className={classes.pieChartLegends}>
        {salesGroupCategories.map((c, i) => (
          <div
            key={`pie-legend-${i}`}
            style={{
              display: 'flex',
              alignItems: 'center',
              margin: '4px 0',
            }}
          >
            <div
              style={{
                width: 8,
                height: 8,
                borderRadius: 4,
                backgroundColor: pieChartColors[i],
                marginRight: 8,
              }}
            />
            <Typography style={{fontSize: '0.75rem'}}>
              {c.name || '--'}
            </Typography>
          </div>
        ))}
      </div>
    </div>
  );
  const productSalesChart = (
    <>
      {productData && productData.length ? (
        productData.map((p, i) => {
          if (i > 2 && !showMoreProds) return null;
          return (
            <div className={classes.product} key={`product-${i}`}>
              <Typography className={classes.productNumber}>
                {i + 1}.
              </Typography>
              <img
                className={classes.productImage}
                src={getImageUrl(p.imageId ? p.imageId : null)}
                alt=""
              />
              <Typography className={classes.productName}>{p.name}</Typography>
              <Typography className={classes.productSalesCount}>
                <b>{p.salesCount}</b>
                <br /> Ventas
              </Typography>
            </div>
          );
        })
      ) : (
        <>
          {[
            {imageId: null, name: 'Nombre Producto', salesCount: 1},
            {imageId: null, name: 'Nombre Producto', salesCount: 1},
            {imageId: null, name: 'Nombre Producto', salesCount: 1},
          ].map((p, i) => {
            return (
              <div className={classes.product} key={`product-${i}`}>
                <Typography className={classes.productNumber}>
                  {i + 1}.
                </Typography>
                <img
                  className={classes.productImage}
                  src={getImageUrl(p.imageId ? p.imageId : null)}
                  alt=""
                />
                <Typography className={classes.productName}>
                  {p.name}
                </Typography>
                <Typography className={classes.productSalesCount}>
                  <b>{p.salesCount}</b>
                  <br /> Ventas
                </Typography>
              </div>
            );
          })}
          <div className={classes.emptyChartBackdrop}>
            <div className={classes.emptyChartAlert}>
              Todavía no tiene las ventas suficientes para generar este gráfico
            </div>
          </div>
        </>
      )}
      {productData && productData.length ? (
        <>
          <Divider className={classes.divider} style={{marginTop: 16}} />
          <CustomButton
            style={{marginTop: 16}}
            onClick={() => setShowMoreProds(!showMoreProds)}
          >
            {showMoreProds ? 'Ver menos' : 'Ver más'}
          </CustomButton>
        </>
      ) : null}
    </>
  );

  const withReferrers = (
    <>
      <Hidden lgUp>
        <div className={classes.containerEarnedPoints}>
          <Typography className={classes.earnedText}>Puntos ganados</Typography>
          <Typography className={classes.earnedPoints}>{points}</Typography>
        </div>
      </Hidden>
      <Hidden mdDown>
        <div className={classes.containerShowPoints}>
          <div className={classes.showPoints}>
            <Typography className={classes.smallEarnedText}>
              Puntos <br /> ganados
            </Typography>
            <Typography className={classes.earnedPoints}>{points}</Typography>
          </div>
        </div>
      </Hidden>
    </>
  );

  const learnTiendadaPro = store && (
    <div className={classes.learnPro}>
      {LEGACY_TIERS.includes(store.storeTier.name) ? (
        <>
          <Typography className={classes.textPro} id="pro-information">
            Aprende sobre <br /> <span>TiendaDa PRO</span>
          </Typography>
          <CustomButton
            className={classes.seeDetails}
            color="primary"
            href="https://www.youtube.com/playlist?list=PL13pnbfPAT8BvlkSZ7XTobKf2fyDx5s-6"
            target="_blank"
            rel="noopener noreferrer"
          >
            Ver detalles
          </CustomButton>
        </>
      ) : (
        <>
          <Typography className={classes.textPro} id="pro-information">
            Entérate de todas nuestras novedades en <span>Telegram</span>
          </Typography>
          <CustomButton
            className={classes.seeDetails}
            color="primary"
            href="https://t.me/tiendada"
            target="_blank"
            rel="noopener noreferrer"
          >
            Únete aquí
          </CustomButton>
        </>
      )}
    </div>
  );

  const [telegramModal, setTelegramModal] = useState(false);
  const [referralModal, setReferralModal] = useState(false);

  if (!user || isFetchingData) {
    return null;
  }

  return (
    <>
      <ConsultancyPageAlert />
      <div className={classes.root}>
        <AlertDueDateTier />
        <Typography className={classes.greeting}>
          Hola <span className={classes.bold}>{user && user.firstName}!</span>
        </Typography>
        <div className={classes.welcome}>
          <Typography>
            {`Te mostramos el resumen de ${dayjs().format('MMMM')}`}
          </Typography>
          <div style={{display: 'flex', alignItems: 'center'}}>
            {store && NON_PAID_TIERS.includes(store.storeTier.name) && (
              <CustomButton
                className={classes.tutorialsButton}
                to="/tiers-list"
              >
                Mejorar plan
              </CustomButton>
            )}
            <CustomButton
              href={TIENDADA_LINKS.youtube.main_channel}
              target="_blank"
              rel="noopener noreferrer"
              className={classes.tutorialsButton}
              startIcon={<PlayCircleFilledTwoTone />}
            >
              Tutoriales
            </CustomButton>
          </div>
        </div>
        <FreeTrialBanner />
        <div className={classes.pageViewCountBanner}>
          <img src={whiteGlobe} alt="" />
          <div style={{textAlign: 'center'}}>
            <Typography className={classes.pageViewsText}>
              Visitas a tu web
            </Typography>
            <Hidden smUp>
              <PageViewsShareStoreButton />
            </Hidden>
          </div>
          <Typography className={classes.pageViews} id="store-visits">
            &nbsp;{pageViews}&nbsp;
            <Tooltip
              classes={{tooltip: classes.infoTooltip}}
              placement="right"
              title="Total histórico de visitas únicas. Puede diferir de la suma del gráfico porque un mismo visitante puede aparecer en varios períodos, pero en el total solo se cuenta una vez. La información puede tardar unos minutos en actualizar."
            >
              <InfoOutlined
                color="primary"
                className={classes.actionButtonInfoIcon}
              />
            </Tooltip>
          </Typography>
          <Hidden mdDown>
            <Divider orientation="vertical" className={classes.divider} />
            <div style={{display: 'flex', alignItems: 'flex-end'}}>
              <Typography>URL de tienda:</Typography>
              <Typography
                id="store-url"
                className={classes.pageViewsBannerDomain}
              >
                {store && getCustomDomain(store)}
              </Typography>
            </div>
          </Hidden>
          <Hidden xsDown>
            <PageViewsShareStoreButton />
          </Hidden>
        </div>
        <div className={classes.gridContainer}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Grid container spacing={3}>
                    {orderData &&
                      ORDER_STATES.map((state, index: number) => {
                        if (!['CANCELLED'].includes(state)) {
                          const item = orderData.find(
                            o => o.orderState === state
                          );
                          if (item)
                            return (
                              <Grid
                                key={`order-dashboard-${index}`}
                                item
                                xs={12}
                                lg={2}
                              >
                                {currency && (
                                  <OrderCard
                                    quantity={item.orders}
                                    totalAmount={item.totalAmount}
                                    label={item.orderState}
                                    currencySymbol={currency.symbol}
                                    user={user}
                                  />
                                )}
                              </Grid>
                            );
                          else return null;
                        } else return null;
                      })}
                    <Grid item xs={12} lg={2}>
                      <Grid
                        container
                        spacing={3}
                        // direction="column"
                      >
                        <Grid style={{height: '100%'}} item xs={6} lg={12}>
                          <div
                            className={`${classes.dashboardItem} ${classes.dashboardItemClickable}`}
                            onClick={() => history.push('/products')}
                          >
                            <div className={classes.cardContent}>
                              <div className={classes.col}>
                                <Typography className={classes.titleText}>
                                  Productos
                                </Typography>
                                <Typography
                                  className={classes.amountCard}
                                  id="total-products"
                                >
                                  {productsCount || 0}
                                </Typography>
                              </div>
                              <div className={classes.wraperIcon}>
                                <LocalMallOutlinedIcon
                                  className={classes.icon}
                                />
                              </div>
                            </div>
                          </div>
                        </Grid>
                        <Grid item xs={6} lg={12}>
                          <div
                            className={`${classes.dashboardItem} ${classes.dashboardItemClickable}`}
                            onClick={() =>
                              history.push(`/products?categoryEdit=1`)
                            }
                          >
                            <div className={classes.cardContent}>
                              <div className={classes.col}>
                                <Typography className={classes.titleText}>
                                  Categorias
                                </Typography>
                                <Typography
                                  className={classes.amountCard}
                                  id="total-categories"
                                >
                                  {productCategoryData &&
                                    productCategoryData.categoriesCount}
                                </Typography>
                              </div>
                              <div className={classes.wraperIcon}>
                                <DashboardOutlinedIcon
                                  className={classes.icon}
                                />
                              </div>
                            </div>
                          </div>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            {!hasFullDashboardFeature && (
              <Divider
                className={classes.divider}
                style={{width: '-webkit-fill-available', margin: 16}}
              />
            )}
            <Grid item xs={12} lg={8}>
              <Grid container spacing={3}>
                {hasFullDashboardFeature && (
                  <Grid item xs={12}>
                    <div className={classes.dashboardItem}>
                      <Typography className={classes.dashboardItemTitle}>
                        Ventas
                      </Typography>
                      {processedSalesData && (
                        <>
                          <Hidden xsDown>
                            <ResponsiveContainer width="100%" height={300}>
                              <BarChart
                                // width={500}
                                // height={300}
                                data={processedSalesData}
                                margin={{
                                  top: 16,
                                  right: 24,
                                  left: 24,
                                  bottom: 0,
                                }}
                              >
                                <CartesianGrid
                                  strokeDasharray="8 8"
                                  vertical={false}
                                />
                                <XAxis
                                  dataKey="month"
                                  axisLine={false}
                                  tickLine={false}
                                  height={40}
                                  tickMargin={16}
                                  tick={{
                                    fontSize: '0.875rem',
                                    fontWeight: 500,
                                    color: '#B8B8C7',
                                  }}
                                />
                                <YAxis tickCount={7} dataKey="amount" hide />
                                <RechartsTooltip
                                  content={
                                    <CustomBarchartTooltip
                                      currency={currency}
                                    />
                                  }
                                />
                                <Bar
                                  dataKey="amount"
                                  fill="#7B39FF"
                                  barSize={16}
                                  radius={8}
                                />
                              </BarChart>
                            </ResponsiveContainer>
                          </Hidden>
                          <Hidden smUp>
                            <ResponsiveContainer width="100%" height={300}>
                              <BarChart
                                layout="vertical"
                                // width={500}
                                // height={300}
                                data={processedSalesData}
                                margin={{
                                  top: 0,
                                  // right: 88,
                                  right: 0,
                                  left: -8,
                                  bottom: 0,
                                }}
                              >
                                <CartesianGrid
                                  strokeDasharray="8 8"
                                  vertical={false}
                                  horizontal={false}
                                />
                                <XAxis dataKey="amount" type="number" hide />
                                <YAxis
                                  dataKey="month"
                                  axisLine={false}
                                  tickLine={false}
                                  type="category"
                                  tickMargin={8}
                                  tick={{
                                    fontSize: '0.875rem',
                                    fontWeight: 500,
                                    color: '#B8B8C7',
                                  }}
                                />
                                <RechartsTooltip
                                  content={
                                    <CustomBarchartTooltip
                                      currency={currency}
                                    />
                                  }
                                />
                                <Bar
                                  dataKey="amount"
                                  fill="#7B39FF"
                                  barSize={16}
                                  radius={8}
                                ></Bar>
                              </BarChart>
                            </ResponsiveContainer>
                          </Hidden>
                          {emptySalesData && (
                            <div className={classes.emptyChartBackdrop}>
                              <div className={classes.emptyChartAlert}>
                                Necesitas mas ventas para poder generar un
                                gráfico de progreso
                              </div>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </Grid>
                )}
                {hasFullDashboardFeature && (
                  <>
                    <Hidden lgUp>
                      <OtherConfigurations />

                      <Grid item xs={12}>
                        <div className={classes.dashboardItem}>
                          <Typography
                            className={classes.dashboardItemTitle}
                            id="category-sales"
                          >
                            Ventas por categoría
                          </Typography>
                          {salesPerCategory && salesPerCategory.length ? (
                            <>
                              <Typography className={classes.chartDescription}>
                                {`${salesPerCategory.length ||
                                  ''} categorías mas vendidas`}
                              </Typography>
                              {pieChart}
                            </>
                          ) : (
                            <>
                              {pieChart}
                              <div className={classes.emptyChartBackdrop}>
                                <div className={classes.emptyChartAlert}>
                                  Todavía no tiene las ventas suficientes para
                                  generar este gráfico
                                </div>
                              </div>
                              <CustomButton
                                component={Link}
                                to="/categories"
                                style={{marginTop: '1rem'}}
                              >
                                Ir a crear categorías
                              </CustomButton>
                            </>
                          )}
                        </div>
                      </Grid>
                      <Grid item xs={12}>
                        <div className={classes.dashboardItem}>
                          <Typography
                            className={classes.dashboardItemTitle}
                            id="bestsellers"
                          >
                            Productos más vendidos
                          </Typography>
                          {productSalesChart}
                        </div>
                      </Grid>
                    </Hidden>
                  </>
                )}
                {hasFullDashboardFeature ? (
                  <>
                    <Grid item xs={12} sm={6}>
                      {haveReferreds ? (
                        <CustomButton
                          className={classes.referralBtn}
                          component={Link}
                          to="/profile/referral"
                        >
                          <div
                            className={classes.extraButton}
                            style={{height: 'unset'}}
                          >
                            <div className={classes.wrapperImgReferred}>
                              <Typography
                                className={classes.extraButtonText}
                                id="referrals"
                              >
                                Ver referidos
                              </Typography>
                              <img
                                src={referralImg}
                                alt="Invita a tus amigos"
                                className={classes.inviteFriend}
                              />
                            </div>
                            {withReferrers}
                          </div>
                        </CustomButton>
                      ) : (
                        <div className={classes.extraButton}>
                          <div className={classes.wrapperImgReferred}>
                            <Typography
                              className={classes.extraButtonText}
                              id="referrals"
                            >
                              Usa TiendaDa GRATIS invitando a tus amigos
                            </Typography>
                            <CustomButton
                              className={classes.btnKnowReferral}
                              onClick={() => setReferralModal(true)}
                            >
                              Conoce más
                            </CustomButton>
                          </div>
                          <img
                            src={referralImg}
                            alt="Invita a tus amigos"
                            className={classes.inviteFriend}
                          />
                        </div>
                      )}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <div
                        className={classes.dashboardItem}
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        {learnTiendadaPro}
                      </div>
                    </Grid>
                    <Grid item lg={12}>
                      <EventsSection size="medium" />
                    </Grid>
                  </>
                ) : (
                  <>
                    <Grid item xs={12} sm={6}>
                      <div className={classes.dashboardItem}>
                        <Typography
                          className={classes.dashboardItemTitle}
                          id="category-sales"
                        >
                          Ventas por categoría
                        </Typography>
                        {salesGroupCategories && salesGroupCategories.length ? (
                          <>
                            <Typography className={classes.chartDescription}>
                              {`${salesGroupCategories.length ||
                                ''} categorías mas vendidas`}
                            </Typography>
                            {pieChart}
                          </>
                        ) : (
                          <>
                            {pieChart}
                            <div className={classes.emptyChartBackdrop}>
                              <div className={classes.emptyChartAlert}>
                                Todavía no tiene las ventas suficientes para
                                generar este gráfico
                              </div>
                            </div>
                            <CustomButton
                              component={Link}
                              to="/categories"
                              style={{marginTop: '1rem'}}
                            >
                              Ir a crear categorías
                            </CustomButton>
                          </>
                        )}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <div className={classes.dashboardItem}>
                        <Typography
                          className={classes.dashboardItemTitle}
                          id="bestsellers"
                        >
                          Productos más vendidos
                        </Typography>
                        {productSalesChart}
                      </div>
                    </Grid>
                  </>
                )}
              </Grid>
            </Grid>
            {hasFullDashboardFeature && (
              <Hidden mdDown>
                <Grid item xs={12} lg={4}>
                  <Grid container direction="column" spacing={3}>
                    <OtherConfigurations />
                    <Grid item>
                      <div className={classes.dashboardItem}>
                        <Typography
                          className={classes.dashboardItemTitle}
                          id="category-sales"
                        >
                          Ventas por categoría
                        </Typography>
                        {salesGroupCategories && salesGroupCategories.length ? (
                          <>
                            <Typography className={classes.chartDescription}>
                              {`${salesGroupCategories.length ||
                                ''} categorías mas vendidas`}
                            </Typography>
                            {pieChart}
                          </>
                        ) : (
                          <>
                            {pieChart}
                            <div className={classes.emptyChartBackdrop}>
                              <div className={classes.emptyChartAlert}>
                                Todavía no tiene las ventas suficientes para
                                generar este gráfico
                              </div>
                            </div>
                            <CustomButton
                              component={Link}
                              to="/categories"
                              style={{marginTop: '1rem'}}
                            >
                              Ir a crear categorías
                            </CustomButton>
                          </>
                        )}
                      </div>
                    </Grid>
                    <Grid item>
                      <div className={classes.dashboardItem}>
                        <Typography
                          className={classes.dashboardItemTitle}
                          id="bestsellers"
                        >
                          Productos más vendidos
                        </Typography>
                        {productSalesChart}
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </Hidden>
            )}
          </Grid>
        </div>
        <TelegramModal
          open={telegramModal}
          handleCloseModal={() => setTelegramModal(false)}
        />
        <ReferralModal
          open={referralModal}
          handleCloseModal={() => setReferralModal(false)}
        />
      </div>
    </>
  );
}

Dashboard.propTypes = {
  user: PropTypes.object,
  store: PropTypes.object,
  orderData: PropTypes.array,
  productsCount: PropTypes.number,
  productCategoryData: PropTypes.object,
  productData: PropTypes.array,
  salesData: PropTypes.array,
  isFetchingData: PropTypes.bool,
  error: PropTypes.string,
  dateIni: PropTypes.instanceOf(Date),
  errorAnalyticsFetched: PropTypes.string,
  fetchDataAnalytics: PropTypes.func,
  fetchPageViews: PropTypes.func,
  pageViews: PropTypes.number,
  fetchSummaryProducts: PropTypes.func,
  fetchSummaryOrderss: PropTypes.func,
  fetchSummaryProductCategories: PropTypes.func,
  fetchSummaryProductsCount: PropTypes.func.isRequired,
  fetchSummarySales: PropTypes.func,
  resellerInformation: PropTypes.object,
  isFetchingResellerInformation: PropTypes.bool,
  points: PropTypes.number,
  subscription: PropTypes.object,
  subscriptionSetting: PropTypes.object,
};
